export const defaultLocale = "fr";

export const baseUrl = "https://pro.vanuxeem.com";
